export default __webpack_public_path__ + "static/media/warning-icon.be82d981.svg";